import { Stack } from '@mui/material';
import useTranslation, { Translation } from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { tooltipPalette } from 'theme/tooltipPalette';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';
import { StatusLegendEntry, StatusLegendItem } from 'v2/components/StatusLegendItem/StatusLegendItem';

const getCardStatusLegendEntries = (translation: Translation): StatusLegendEntry[] => [
  {
    label: translation.card_status_tooltip_all_is_okay,
    color: tooltipPalette.success.main,
    filled: true
  },
  {
    label: translation.card_status_tooltip_action_required_soon,
    color: tooltipPalette.warning.main,
    filled: true
  },
  {
    label: translation.card_status_tooltip_action_required,
    color: tooltipPalette.error.main,
    filled: true
  },
  {
    label: translation.blocked,
    color: tooltipPalette.text.secondary,
    filled: false
  }
];

export const CardColumnHeader: React.FC = () => {
  const { translation } = useTranslation();
  const entries = getCardStatusLegendEntries(translation);

  return (
    <ColumnHeaderWithTooltip
      label={translation.card}
      tooltip={
        <Stack spacing={1}>
          {entries.map((entry) => (
            <StatusLegendItem key={entry.label} {...entry} />
          ))}
        </Stack>
      }
    />
  );
};
